import angular from 'angular';
import books from '../books';
import './App.scss';
/** Initial Setup */
import { initialSetupComponent } from './initialSetup';
/** Dialogs */
import initialSetupDialog from './dialogs/initialSetupDialog';
/** Dom */
import initialSetupDom from './dom/initialSetupDom';
/** Services */
import initialSetupServices from './services/initialSetupServices';
/** Types */
import initialSetupTypes from './types/initialSetupTypes';

/*******************************************************************************
 * @ngdoc  overview
 * @module csm.books.InitialSetup
 * @description
 * Base module of the ASB Works/myPTEZ/Booster Finance application for setting up
 * the organization books.
 *******************************************************************************/
export default angular
  .module('csm.books.InitialSetup', [
    books,
    initialSetupDialog,
    initialSetupDom,
    initialSetupServices,
    initialSetupTypes,
    'ui.grid',
    'ui.grid.emptyBaseLayer',
    'ui.grid.resizeColumns'
  ])
  .component('initialSetup', initialSetupComponent).name;
